var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    {
      staticClass: "inspection-details-tr",
      attrs: { id: "inspection-details-" + _vm.row.id }
    },
    [
      _c("td", { staticClass: "py-0", attrs: { colspan: "100%" } }, [
        _c("div", { staticClass: "row" }, [
          !_vm.isPeriodic
            ? _c("div", { staticClass: "col-12 col-md-5" }, [
                _c("div", { staticClass: "content" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v("\n            Access Instructions\n          ")
                  ]),
                  _c(
                    "div",
                    { staticClass: "mb-3" },
                    [
                      _c("span", { staticClass: "font-weight-bold" }, [
                        _vm._v("Lockbox / Keypad Code:")
                      ]),
                      _c(
                        "span",
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.row.lock_box_code) +
                              "\n              "
                          ),
                          _c("q-icon", {
                            attrs: {
                              name: "edit",
                              size: "16px",
                              color: "primary"
                            }
                          }),
                          _c(
                            "q-popup-edit",
                            {
                              on: {
                                save: function(value, oldValue) {
                                  return (
                                    value !== oldValue &&
                                    _vm.updateInspection({
                                      lock_box_code: value || null
                                    })
                                  )
                                }
                              },
                              model: {
                                value: _vm.row.lock_box_code,
                                callback: function($$v) {
                                  _vm.$set(_vm.row, "lock_box_code", $$v)
                                },
                                expression: "row.lock_box_code"
                              }
                            },
                            [
                              _c("q-input", {
                                attrs: { autofocus: "" },
                                model: {
                                  value: _vm.row.lock_box_code,
                                  callback: function($$v) {
                                    _vm.$set(_vm.row, "lock_box_code", $$v)
                                  },
                                  expression: "row.lock_box_code"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("SdCopyToClipboard", {
                        staticClass: "ml-2",
                        attrs: { "with-icon": "", copy: _vm.row.lock_box_code }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c("span", { staticClass: "font-weight-bold" }, [
                        _vm._v("Instructions:")
                      ]),
                      _c(
                        "span",
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.row.access_instructions) +
                              "\n              "
                          ),
                          _c("q-icon", {
                            attrs: {
                              name: "edit",
                              size: "16px",
                              color: "primary"
                            }
                          }),
                          _c(
                            "q-popup-edit",
                            {
                              staticClass: "inspection-details-textarea-popup",
                              attrs: { buttons: "" },
                              on: {
                                save: function(value, oldValue) {
                                  return (
                                    value !== oldValue &&
                                    _vm.updateInspection({
                                      access_instructions: value || null
                                    })
                                  )
                                }
                              },
                              model: {
                                value: _vm.row.access_instructions,
                                callback: function($$v) {
                                  _vm.$set(_vm.row, "access_instructions", $$v)
                                },
                                expression: "row.access_instructions"
                              }
                            },
                            [
                              _c("q-input", {
                                attrs: { type: "textarea", autofocus: "" },
                                on: {
                                  keyup: function($event) {
                                    if (
                                      !("button" in $event) &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.stopPropagation()
                                  }
                                },
                                model: {
                                  value: _vm.row.access_instructions,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.row,
                                      "access_instructions",
                                      $$v
                                    )
                                  },
                                  expression: "row.access_instructions"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("SdCopyToClipboard", {
                        staticClass: "ml-2",
                        attrs: {
                          "with-icon": "",
                          copy: _vm.row.access_instructions
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            : _vm._e(),
          _vm.isPeriodic
            ? _c("div", { staticClass: "col-12 col-md-3" }, [
                _c(
                  "div",
                  { staticClass: "content" },
                  [
                    _c("div", { staticClass: "title" }, [
                      _vm._v("\n            Tenants\n          ")
                    ]),
                    _vm.row.tenants && _vm.row.tenants.length
                      ? _vm._l(_vm.row.tenants, function(tenant, index) {
                          return _c(
                            "q-chip",
                            {
                              key: "tenant_" + index,
                              staticClass: "p-1 w-100 mb-2",
                              attrs: { dense: "", clickable: "" }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "float-left" },
                                [
                                  _c(
                                    "SdCopyToClipboard",
                                    {
                                      directives: [
                                        { name: "tippy", rawName: "v-tippy" }
                                      ],
                                      attrs: {
                                        copy:
                                          tenant.full_name +
                                          ", " +
                                          tenant.formatted_phone_number +
                                          ",  " +
                                          tenant.email,
                                        "with-icon": true,
                                        title:
                                          tenant.full_name +
                                          ", " +
                                          tenant.formatted_phone_number +
                                          ",  " +
                                          tenant.email
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "font-weight-bold mr-2"
                                        },
                                        [_vm._v(_vm._s(tenant.full_name))]
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "float-right" },
                                [
                                  tenant.formatted_phone_number
                                    ? _c(
                                        "SdCopyToClipboard",
                                        {
                                          attrs: {
                                            copy: tenant.formatted_phone_number
                                          }
                                        },
                                        [
                                          _c("q-icon", {
                                            directives: [
                                              {
                                                name: "tippy",
                                                rawName: "v-tippy"
                                              }
                                            ],
                                            attrs: {
                                              name: "phone",
                                              title:
                                                tenant.formatted_phone_number
                                            }
                                          }),
                                          _c("q-icon", {
                                            attrs: { name: "content_copy" }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  tenant.email
                                    ? _c(
                                        "SdCopyToClipboard",
                                        { attrs: { copy: tenant.email } },
                                        [
                                          _c("q-icon", {
                                            directives: [
                                              {
                                                name: "tippy",
                                                rawName: "v-tippy"
                                              }
                                            ],
                                            attrs: {
                                              name: "email",
                                              title: tenant.email
                                            }
                                          }),
                                          _c("q-icon", {
                                            attrs: { name: "content_copy" }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c("edit-inspection-tenant", {
                                    attrs: { tenant: tenant },
                                    on: { save: _vm.updateTenant }
                                  }),
                                  index > 0
                                    ? _c("q-icon", {
                                        staticClass: "cursor-pointer ml-2",
                                        attrs: {
                                          name: "delete",
                                          size: "16px",
                                          color: "red"
                                        },
                                        nativeOn: {
                                          click: function($event) {
                                            _vm.deleteTenant(index)
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          )
                        })
                      : _vm._e(),
                    _c(
                      "edit-inspection-tenant",
                      {
                        staticClass: "d-block cursor-pointer",
                        on: { save: _vm.updateTenant }
                      },
                      [_vm._v("\n            Add\n          ")]
                    ),
                    _vm.showSchedulingLink
                      ? _c(
                          "div",
                          { staticClass: "my-2" },
                          [
                            _vm._v(
                              "\n            Tenant scheduling link:\n            "
                            ),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.row.tenant_scheduling_url.startsWith(
                                    "http"
                                  )
                                    ? _vm.row.tenant_scheduling_url
                                    : "//" + _vm.row.tenant_scheduling_url,
                                  target: "_blank"
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.row.tenant_scheduling_url) +
                                    "\n            "
                                )
                              ]
                            ),
                            _c("SdCopyToClipboard", {
                              staticClass: "ml-2",
                              attrs: {
                                "with-icon": "",
                                copy: _vm.row.tenant_scheduling_url
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  2
                )
              ])
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "col-12",
              class: _vm.isPeriodic ? "col-md-7" : "col-md-5"
            },
            [
              _c(
                "div",
                { staticClass: "content" },
                [
                  _c("div", { staticClass: "title" }, [
                    _vm._v("\n            Additional notes\n            "),
                    this.row.type === this.$config.inspectionTypes.MOVE_IN_OUT
                      ? _c("p", { staticClass: "floor-plan-details" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.floorPlanDetails) +
                              "\n            "
                          )
                        ])
                      : _vm._e()
                  ]),
                  _c(
                    "span",
                    { staticClass: "pre-line" },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.row.instructions) +
                          "\n            "
                      ),
                      _c("q-icon", {
                        attrs: { name: "edit", size: "16px", color: "primary" }
                      }),
                      _c(
                        "q-popup-edit",
                        {
                          staticClass: "inspection-details-textarea-popup",
                          attrs: { buttons: "" },
                          on: {
                            save: function(value, oldValue) {
                              return (
                                value !== oldValue &&
                                _vm.updateInspection({
                                  instructions: value || null
                                })
                              )
                            }
                          },
                          model: {
                            value: _vm.row.instructions,
                            callback: function($$v) {
                              _vm.$set(_vm.row, "instructions", $$v)
                            },
                            expression: "row.instructions"
                          }
                        },
                        [
                          _c("q-input", {
                            attrs: { type: "textarea", autofocus: "" },
                            on: {
                              keyup: function($event) {
                                if (
                                  !("button" in $event) &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                $event.stopPropagation()
                              }
                            },
                            model: {
                              value: _vm.row.instructions,
                              callback: function($$v) {
                                _vm.$set(_vm.row, "instructions", $$v)
                              },
                              expression: "row.instructions"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("SdCopyToClipboard", {
                    staticClass: "ml-2",
                    attrs: { "with-icon": "", copy: _vm.row.instructions }
                  })
                ],
                1
              )
            ]
          ),
          _c("div", { staticClass: "col-12 col-md-2" }, [
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "title" }, [
                _vm._v("\n            Pricing\n          ")
              ]),
              _c("div", { staticClass: "mb-3" }, [
                _vm._v(
                  "\n            Pm payment: $" +
                    _vm._s(_vm.row.price) +
                    "\n          "
                )
              ]),
              _c(
                "div",
                { staticClass: "mb-3" },
                [
                  _vm._v(
                    "\n            Agent payout: $" +
                      _vm._s(_vm.row.agent_payout) +
                      "\n            "
                  ),
                  !_vm.transactions.transfer
                    ? _c(
                        "span",
                        [
                          _c("q-icon", {
                            attrs: {
                              name: "edit",
                              size: "16px",
                              color: "primary"
                            }
                          }),
                          _c(
                            "q-popup-edit",
                            {
                              on: {
                                save: function(value, oldValue) {
                                  return (
                                    value !== oldValue &&
                                    _vm.updateInspection({
                                      agent_payout: value || 0
                                    })
                                  )
                                },
                                hide: function($event) {
                                  _vm.checkValue(_vm.row.agent_payout, _vm.row)
                                }
                              },
                              model: {
                                value: _vm.row.agent_payout,
                                callback: function($$v) {
                                  _vm.$set(_vm.row, "agent_payout", $$v)
                                },
                                expression: "row.agent_payout"
                              }
                            },
                            [
                              _c("q-input", {
                                attrs: { type: "number", autofocus: "" },
                                model: {
                                  value: _vm.row.agent_payout,
                                  callback: function($$v) {
                                    _vm.$set(_vm.row, "agent_payout", $$v)
                                  },
                                  expression: "row.agent_payout"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.transactions.transfer
                    ? _c(
                        "router-link",
                        {
                          staticClass: "q-mr-sm",
                          attrs: {
                            to: {
                              name: "app.transactions",
                              params: { id: _vm.transactions.transfer.id }
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              #" +
                              _vm._s(_vm.transactions.transfer.id) +
                              "\n            "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }